import React from "react";

import { connect } from 'react-redux';

// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import AboutCustomer from "./AddCustomerSteps/AboutCustomer";
import Address from "./AddCustomerSteps/Address";
import Contact from "./AddCustomerSteps/Contact";
import { store } from "../../redux/store";
import { ADD_CUSTOMER_FORM_CLEAR, SET_CUSTOMER_LIST } from "../../redux/types";
import Api from "../../api/Api.js";
import CustomerEndpoints from "../../api/CustomerEndpoints";
import { replace } from "connected-react-router";

class AddCustomer extends React.Component {

  state = {
    isPrepaid: this.props.current_add_form.prepaid || false
  }

  render() {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Wizard
            validate
            steps={[
              { stepName: "About", stepComponent: AboutCustomer, stepId: "about", props: { users: this.props.users, onPrepaidChange: (isPrepaid) => this.setState({ isPrepaid }), isPrepaid: this.state.isPrepaid, defaultAccount: this.props.current_add_form } },
              { stepName: "Addresses", stepComponent: Address, stepId: "address", props: { isPrepaid: this.state.isPrepaid, defaultPostal: this.props.current_add_form.postal || {}, defaultPhysical: this.props.current_add_form.physical || {} } },
              { stepName: "Contact Info", stepComponent: Contact, stepId: "contact", props: { isPrepaid: this.state.isPrepaid, defaultTechnical: this.props.current_add_form.technical, defaultBusiness: this.props.current_add_form.business, defaultFinancial: this.props.current_add_form.financial } }
            ]}
            title={"Setup a new " + (this.state.isPrepaid ? "Prepaid" : "") + " Customer"}
            subtitle="Make sure the account doesn't exist before you try and add it"
            finishButtonClick={() => {
              console.log("FINISH CLICKED");
              this.setState({ loading: true }, () => {
                console.log(this.props.current_add_form);

                var newCustomer = {
                  ...this.props.current_add_form,
                  sales_id: (this.props.current_add_form.sales || {}).value || null,
                  country: this.props.current_add_form.value || "ZA",
                  active: true,
                  verified: true,
                  closed: false
                };

                if (newCustomer.business)
                  newCustomer.business.email = { emailaddress: this.props.current_add_form.business.email }
                if (newCustomer.financial)
                  newCustomer.financial.email = { emailaddress: this.props.current_add_form.financial.email }
                if (newCustomer.technical)
                  newCustomer.technical.email = { emailaddress: this.props.current_add_form.technical.email }

                if (newCustomer.physical && newCustomer.physical.address) {

                  var physical_address_lines = newCustomer.physical.address.split("\n");

                  for (var i = 0; i < physical_address_lines.length; i++) {
                    newCustomer.physical["address_line_" + (i + 1)] = physical_address_lines[i];
                  }
                }

                if (newCustomer.postal && newCustomer.postal.address) {
                  var postal_address_lines = newCustomer.postal.address.split("\n");

                  for (var i = 0; i < postal_address_lines.length; i++) {
                    newCustomer.postal["address_line_" + (i + 1)] = postal_address_lines[i];
                  }
                }

                Api.post(CustomerEndpoints.add, newCustomer)
                  .then(({ data }) => {
                    store.dispatch({ type: ADD_CUSTOMER_FORM_CLEAR });
                    Api.get(CustomerEndpoints.list)
                      .then((customers) => {
                        store.dispatch({ type: SET_CUSTOMER_LIST, payload: customers.data });
                        store.dispatch(replace('/customer/view/' + data.id));
                      })
                      .catch((e) => console.error(e))
                  })
                  .catch((e) => console.error(e))
              });
            }}
            initialStates={this.props.current_add_form}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({ current_add_form: state.customers.addForm, users: state.allUsers.list });

export default connect(mapStateToProps)(AddCustomer);